import axios from "axios"

export const findNotifications = (headers) => {
    return axios.get(
        `${process.env.REACT_APP_MANAGEMENT_API_URL}/notifications`,
        {
            headers
        }
    )
}

export const deleteNotifications = (headers, id) => {
    return axios.delete(
        `${process.env.REACT_APP_MANAGEMENT_API_URL}/notifications/${id}`,
        {
            headers
        }
    )
}